import React from "react";
import {Slide} from "@mui/material";

// Shared dialog transition. Kept in its own module so that components which only
// need the transition (e.g. Profile) don't statically pull in the whole Search
// page, which would defeat code-splitting of Search.
export const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
